<template>
  <section class="fullscreen-landing-section">
    <div class="overlay">
      <div class="full-section sectioned landing">
        <div class="container">
          <div class="landing-content landing-header">
            <span class="mini-title">{{ $t('landing.miniTitle') }}</span>
            <span class="heading-title">{{ $t('landing.headingTitle') }}</span>
            <hr>
            <span class="paragraph">{{ $t('landing.paragraph') }}</span>
          </div>
          <div class="landing-content cards cards-mini">
            <span class="heading-title">{{ $t('salePage.headingTitle') }}</span>
            <router-link :to="localizedPath('purchase')" class="a-link-card">
              <div class="link-card">
                <div class="card-icon buy"></div>
                <span class="card-title">{{ $t('landing.cards.purchase') }}</span>
              </div>
            </router-link>
            <router-link :to="localizedPath('sale')" class="a-link-card">
              <div class="link-card">
                <div class="card-icon sell"></div>
                <span class="card-title">{{ $t('landing.cards.sale') }}</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="fullscreen-landing-section">
    <div class="overlay">
      <div class="full-section sectioned bg">
        <div class="container">
          <div class="full-section-content">
            <div class="full-image img1"></div>
          </div>
          <div class="full-section-content">
            <span class="full-icon"><i class="fa fa-handshake-o" aria-hidden="true"></i></span>
            <span class="full-title"><span class="colored">{{ $t('full.title1') }}</span> {{ $t('full.title2') }}</span>
            <p>{{ $t('full.section1') }}</p>
            <p>{{ $t('full.section2') }}</p>
            <p>{{ $t('full.section3') }}</p>
            <p>{{ $t('full.section4') }}</p>
          </div>
        </div>
      </div>
      <div class="full-section centered">
        <div class="container">
          <div class="full-section-content">
            <div class="full-image img3"></div>
            <span class="full-title">{{ $t('full2.title1') }}</span>
            <p>{{ $t('full2.part5') }}</p>
          </div>
        </div>
      </div>
      <div class="full-section sectioned">
        <div class="container">
          <div class="full-section-content">
            <div class="full-image img2"></div>
          </div>
          <div class="full-section-content">
            <span class="full-icon"><i class="fa fa-money" aria-hidden="true"></i></span>
            <span class="full-title"><span class="colored">{{ $t('full2.title1') }}</span> {{ $t('full2.title2')
              }}</span>
            <p>{{ $t('full2.part1') }}</p>
            <p>{{ $t('full2.part2') }}</p>
            <p>{{ $t('full2.part3') }}</p>
            <p>{{ $t('full2.part4') }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import { localizedPath } from '@/utiles/localizedPath';

export default {
  name: 'HomePage',
  methods: {
    localizedPath
  },
};
</script>
